import { render, staticRenderFns } from "./add-or-update.vue?vue&type=template&id=45222366&"
import script from "./add-or-update.vue?vue&type=script&lang=js&"
export * from "./add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./add-or-update.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports